module.exports = __webpack_public_path__ + "media/notification.90a6d5af.mp3";